import React, {PropTypes} from 'react';
import './confirm_details.less'
import {Link, browserHistory} from 'react-router';
import LoggedinFooter from '../../footer/loggedin_footer';
import $ from 'jquery';
import moment from 'moment';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../../auth/auth_actions';
import postAShipmentActions from '../post_a_shipment_actions';
import MediaQuery from 'react-responsive';
import packageSizeDetails from '../post_a_shipment_data';
import {toTitleCase,join,localTimestampToGMT} from '../../util/common';
import CONSTANTS from '../../common_constants';
import validate from '../../util/validate';

class ConfirmDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    window.scrollTo(0,0);
  }
  goBack = () =>{
    if(this.state.shipmentId)
      browserHistory.push('/post-a-shipment/delivery-details?shipmentId='+ this.state.shipmentId);
    else
      browserHistory.push('/post-a-shipment/delivery-details');
  }
  componentDidMount(){
    if(validate.isEmpty(this.props.postAShipment))
        browserHistory.push('/post-a-shipment');
    const shipmentId = this.props.location.query.shipmentId;
    this.setState({
      shipmentId
    })
  }
  submit = () =>{
    if(this.state.shipmentId)
      browserHistory.push('/post-a-shipment/payment?shipmentId='+ this.state.shipmentId);
    else
      browserHistory.push('/post-a-shipment/payment');
  }
  saveAsDraft = (e) =>{
    e.preventDefault();
    let parameters = Object.assign({} , this.props.postAShipment);
    parameters.shipmentStatus = 1;
    parameters.shipmentType = 1 ; //post a shipment
    parameters.deliveryDate = localTimestampToGMT(parameters.deliveryDate)
    let value = moment(parameters.deliveryDate)
    if(value.startOf('day').diff(moment().startOf('day') , 'days') == 0)   //check if selected date is today
    {
        parameters.deliveryDate = (new Date(value.unix()*1000).setHours(23,59,59,0))  //store end of the day with 1 minutes less
    }
    this.setState({
      ajaxInProgress : true
    })
    let API = "CREATE";
    if(this.state.shipmentId)
      API = "UPDATE"
    this.props.postAShipmentActions.createAshipment(parameters,API).then(() => {
        this.setState({ajaxInProgress: false});
        browserHistory.push('/dashboard');
    }, (errorRes) => {
        if(errorRes.error === CONSTANTS.sessionInvalid){
          this.setState({ajaxInProgress: false})
          this.props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        this.setState({ajaxInProgress: false,successMsg:""});
    })
  }
  render() {
    const {postAShipment} = this.props ;
    const loader = <div className="loader-button"></div>;
    const defaultImgUrl = "../../../public/images/requester_flow/placeholder.png"
    let imgURL = postAShipment.imageIds ? (postAShipment.imageIds.length > 0 ? postAShipment.imageIds[0] : defaultImgUrl ) : defaultImgUrl;
    let pickupUserName = "I " , deliveryUserName ;
    let itemSize,itemSizeDescription ;
    for(let i = 0; i< packageSizeDetails.data.length ; i++)
    {
      if(postAShipment.itemSize == packageSizeDetails.data[i].id)
      {
        itemSize = packageSizeDetails.data[i].label;
        itemSizeDescription = packageSizeDetails.data[i].description;
        break;
      }
    }
    if(!postAShipment.isIWillMeetCarrierAtPickup)
    {
      pickupUserName = postAShipment.pickupUser ? postAShipment.pickupUser.name : ""
    }
    if(!postAShipment.isIWillMeetCarrierAtDelivery)
    {
      deliveryUserName = postAShipment.deliveryUser ? postAShipment.deliveryUser.name : ""
    }
    return (
      <div id="postShipmentConfirmDetailsWrap">
        <div className = "wrapper post-a-shipment-confirm-details-wrap">
          <div className="back-section" onClick = {this.goBack}>
              <span className="icon-icn_back"></span>
              <span className = "back-content">Back</span>
          </div>
          <div className = "post-a-shipment-confirm-details">
            <div className="title-div">
              <div className="title-div-img" style={{"backgroundImage": 'url("' + imgURL + '")'}}></div>
              <div className="title-div-content">
                <div className="title-heading">
                  {postAShipment.title}
                  </div>
                <div className="title-location">Delivery to {postAShipment.deliveryCity ? postAShipment.deliveryCity+", " : ""} {postAShipment.deliveryCountry}</div>
                <div className="title-cost">${postAShipment.shipmentCost + postAShipment.itemValue}</div>
              </div>
            </div>
            <MediaQuery query='(min-width: 768px)'>
              <div className="shipment-content">
                <div className="shipment-sub-content">
                  <h4 className="shipment-sub-header">
                    <span className="icon-cash-in-hand img-icn"></span>PACKAGE VALUE</h4>
                  <div className="shipment-info">$ {postAShipment.itemValue}</div>
                  <p className="shipment-static-info">Deposit required to carry this package. </p>
                </div>
                  <div className="shipment-sub-content">
                    <h4 className="shipment-sub-header">
                      <span className="icon-box-front img-icn"></span>SIZE</h4>
                    <div className="shipment-info">{itemSize}</div>
                    <p className="shipment-static-info">{itemSizeDescription}</p>
                  </div>
                  <div className="shipment-sub-content">
                    <h4 className="shipment-sub-header">
                      <span className="icon-calendar img-icn"></span>DELIVER BY</h4>
                    <div className="shipment-info">{moment(postAShipment.deliveryDate).format("ll")}</div>
                  </div>
              </div>
              <div className="shipment-content no-border">
                  <div className="shipment-sub-content">
                    <h4 className="shipment-sub-header">
                      <span className="icon-uparrow img-icn"></span>PICKUP</h4>
                    <div className="shipment-info">{postAShipment.pickupLocation}</div>
                    <div className="shipment-info shipment-status-info">{pickupUserName} will meet the carrier</div>
                  </div>
                  <div className="shipment-sub-content">
                    <h4 className="shipment-sub-header">
                      <span className="icon-downarrow img-icn"></span>DELIVERY</h4>
                    <div className="shipment-info">{postAShipment.deliveryLocation}</div>
                    <div className="shipment-info shipment-status-info">{deliveryUserName} will meet the carrier</div>
                  </div>
              </div>
            </MediaQuery>
            <MediaQuery query='(max-width: 767px)'>
              <div className="shipment-details-div">
                  <div className="details-div">
                    <span className="icon-box-front img-icn"></span>{itemSize}
                  </div>
                  <div className="details-div">
                    <span className="icon-cash-in-hand img-icn"></span>$ {postAShipment.itemValue} value
                  </div>
                  <div className="details-div">
                    <span className="icon-calendar img-icn"></span>By {moment(postAShipment.deliveryDate).format("ll")}
                  </div>
              </div>
              <div className="shipment-div-content">
                   <div className="shipment-pickup">
                    <div className="shipment-div-heading">
                      <span className="icon-uparrow img-icn"></span>PICKUP</div>
                    <div className="shipment-pickup-content">{postAShipment.pickupLocation}</div>
                    <div className="shipment-pickup-user">{pickupUserName} will meet the carrier</div>
                  </div>
                  <div className="shipment-delivery">
                    <div className="shipment-div-heading">
                      <span className="icon-downarrow img-icn"></span>DELIVERY</div>
                    <div className="shipment-pickup-content">{postAShipment.deliveryLocation}</div>
                    <div className="shipment-pickup-user">{deliveryUserName} will meet the carrier</div>
                  </div>
              </div>
            </MediaQuery>
            <div className = "submit-section">
              <div className = "submit-options">
                  <button className = "btn orange" onClick = {this.submit} >Proceed to Payment</button>
              </div>
              <div className = "submit-options m-l">
                  <button className = "btn green" onClick = {this.saveAsDraft} >{this.state.ajaxInProgress? loader : 'Save and Exit'}</button>
              </div>
            </div>
          </div>
        </div>
        <LoggedinFooter />
      </div>

    )
  }
}

ConfirmDetails = connect((state) => {
  return {
    postAShipment : state.app.postAShipment
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    postAShipmentActions :bindActionCreators(postAShipmentActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch)
  }
})(ConfirmDetails);

export default ConfirmDetails;



// WEBPACK FOOTER //
// app/post_a_shipment/confirm_details/confirm_details.jsx